module.exports = __webpack_public_path__ + "img/address-book.5b5d2854.svg";